export default "__VITE_ASSET__28f5f0d1__"